import React from "react";
import PropTypes from 'prop-types';
import PositionList from "./PositionList";

export default class PositionListFiltered extends React.Component {

    static propTypes = {
        customerName: PropTypes.string,
        language: PropTypes.string,
        searchString: PropTypes.string,
        searchLocation: PropTypes.string,
        searchBusinessUnit: PropTypes.string,
        searchCompany: PropTypes.string,
        searchPositionType: PropTypes.string,
        positionList: PropTypes.array,
		categorizePositions: PropTypes.bool,
        globalGateEnabled: PropTypes.bool,
        agency: PropTypes.string
    };

    static defaultProps = {
        agency: null
    };

    constructor(props){
        super(props);
        this.state = {
            loading: true,
            language: this.props.language
        };
    }

    getFilteredPositionList()
    {
        let positionListFiltered = this.props.positionList;
        if (this.props.searchString !== undefined && this.props.searchString.length > 0) {
            positionListFiltered = positionListFiltered.filter(
                (position) => {
                    return position.title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(this.props.searchString.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                }
            );
        }
        if (this.props.searchLocation !== undefined && this.props.searchLocation.length > 0) {
            positionListFiltered = positionListFiltered.filter(
                (position) => {
                    return position.region && Object.keys(position.region).includes(this.props.searchLocation);
                }
            );
        }
        if (this.props.searchBusinessUnit !== undefined && this.props.searchBusinessUnit.length > 0) {
            positionListFiltered = positionListFiltered.filter(
                (position) => {
                    return  parseInt(position.businessUnit) ===  parseInt(this.props.searchBusinessUnit);
                }
            );
        }
        if (this.props.searchCompany !== undefined && this.props.searchCompany.length >0) {
            positionListFiltered = positionListFiltered.filter(
                (position) => {
                    return position.companyName === this.props.searchCompany;
                }
            );
        }
        if (this.props.searchPositionType !== undefined && this.props.searchPositionType.length > 0) {
            positionListFiltered = positionListFiltered.filter(
                (position) => {
                    return  parseInt(position.positionType) === parseInt(this.props.searchPositionType);
                }
            );
        }
        return positionListFiltered;
    }

    render() {
        return (
            <PositionList
                language={this.state['language']}
                customerName={this.props.customerName}
                positionList={this.getFilteredPositionList()}
                globalGateEnabled={this.props.globalGateEnabled}
				categorizePositions={this.props.categorizePositions}
                agency={this.props.agency}
            />
		);
    }
}

